var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckliston(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.5,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#17E3AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28033 12.4697C8.98744 12.1768 8.51256 12.1768 8.21967 12.4697C7.92678 12.7626 7.92678 13.2374 8.21967 13.5303L10.7197 16.0303C11.0216 16.3323 11.5143 16.3216 11.8029 16.0068L17.3029 10.0068C17.5828 9.70146 17.5621 9.22703 17.2568 8.94714C16.9515 8.66724 16.477 8.68787 16.1971 8.99321L11.2264 14.4158L9.28033 12.4697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckliston);
export default __webpack_public_path__ + "static/media/Checklist on.2c892f9b012a0330db4c77c7e37ee633.svg";
export { ForwardRef as ReactComponent };